import { render } from "./GuessCount.vue?vue&type=template&id=29832633&scoped=true&ts=true"
import script from "./GuessCount.vue?vue&type=script&lang=ts"
export * from "./GuessCount.vue?vue&type=script&lang=ts"

import "./GuessCount.vue?vue&type=style&index=0&id=29832633&scoped=true&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29832633"]])

export default __exports__